export type ToastSeverity = "success" | "error" | "info" | "warning";

export interface ToastPayload {
  message: string;
  severity?: ToastSeverity;
}

export const ADMIN_TOAST_EVENT = "admin-app-toast";

export const showToast = (message: string, severity: ToastSeverity = "info") => {
  if (!message) return;
  window.dispatchEvent(
    new CustomEvent<ToastPayload>(ADMIN_TOAST_EVENT, {
      detail: { message, severity },
    })
  );
};
